export function getAppliesToBabelKey(
  appliesToCategory: string,
  appliesToProduct: string
): string {
  if (appliesToCategory === 'subscriptions') {
    return 'studio.discountModal.form.appliesToCategoryInput.option.subscriptions';
  } else if (appliesToCategory === 'shop_products') {
    return `studio.discountModal.form.appliesToProductInput.option.${appliesToProduct}`;
  }
  return '';
}
